"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Container = function (_a) {
    var children = _a.children, className = _a.className, type = _a.type;
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-layouts-container', type ? "storybook-layouts-container-" + type : '', className) }, children);
};
exports.Container = Container;
exports.Container.propTypes = {
    /**
     * The HTML inside of the List
     */
    children: prop_types_1.default.any,
    /**
     * Add more classNames to List
     */
    className: prop_types_1.default.string,
    /**
     * Type
     */
    type: prop_types_1.default.oneOf(['default', 'sm', 'md']),
};
